module.exports = __webpack_public_path__ + "img/top.bfafcdd4.png";